/* eslint-disable */
import { produce } from "immer";
import { create } from "zustand";

export type WalletResponseData = {
  //   amount: Number;
  //   isProfitable: boolean;
  //   percentage: Number;
  //   goldBalance: string;
  //   nonInvoicedBalance:string;
  dgTrendLineModel: {
    amount: Number;
    isProfitable: boolean;
    percentage: Number;
  };
  goldBalance: number;
  nonInvoicedBalance: string;
};

export const WalletInitialData = {
  dgTrendLineModel: {
    amount: 0,
    isProfitable: true,
    percentage: 0,
  },
  goldBalance: 0,
  nonInvoicedBalance: "0",
};

export type WalletStore = {
  updateResponse: (wallet: WalletResponseData) => void;
  resetWallet: () => void;
};

// TODO : need to change types by debugging as it is throwing some type errors
export const useWalletStore = create<WalletStore & WalletResponseData>((set: any) => ({
  ...WalletInitialData,
  updateResponse: (verifyData: WalletResponseData) => {
    set(
      produce((state: WalletResponseData) => {
        state.goldBalance = verifyData?.goldBalance;
        // state.dgTrendLineModel={...verifyData?.dgTrendLineModel};
        state.nonInvoicedBalance = verifyData?.nonInvoicedBalance;
        state.dgTrendLineModel.amount = verifyData?.dgTrendLineModel?.amount;
        state.dgTrendLineModel.isProfitable =
          verifyData?.dgTrendLineModel?.isProfitable;
        state.dgTrendLineModel.percentage =
          verifyData?.dgTrendLineModel?.percentage;
      })
    );
  },
  resetWallet: () => set(WalletInitialData),
}));
